import React from 'react';
import { Row, Col } from 'antd';
import _pickBy from 'lodash/pickBy';

import { TCustomerDetails } from 'containers/Customer/i18n/TModules';
import useMultiLanguageTranslation from 'hooks/useMultiLanguageTranslation';

import ChangesRow from './ChangesRow';

interface ChangesDetailProps {
  changes: { [key: string]: (number | string | null | object | boolean)[] };
  entity?: string;
}

const ChangesDetails = ({ changes, entity }: ChangesDetailProps) => {
  const { t } = useMultiLanguageTranslation();
  // filter out all entries whose values are [null, null];
  const filteredChanges = _pickBy(changes, (val: any) => val.some(Boolean));
  return (
    <div>
      <Row gutter={16} style={{ fontWeight: 600, padding: '0 0 1rem' }}>
        <Col span={4}>{t(`${TCustomerDetails}.AuditLog.Details`)}</Col>
        <Col span={10}>{t(`${TCustomerDetails}.AuditLog.Old`)}</Col>
        <Col span={10}>{t(`${TCustomerDetails}.AuditLog.New`)}</Col>
      </Row>
      {Object.keys(filteredChanges).map(key => (
        <ChangesRow key={key} propertyName={key} data={filteredChanges[key]} entity={entity} />
      ))}
    </div>
  );
};

export default ChangesDetails;
